import { useState, useEffect } from 'react';

interface UseTimezoneReturn {
	currentTimezone: string;
}

export function useTimezone(): UseTimezoneReturn {
	const [currentTimezone, setCurrentTimezone] = useState('');

	useEffect(() => {
		const timer = setTimeout(() => {
			try {
				const timezoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
				const offsetMinutes = -new Date().getTimezoneOffset();
				const offsetSign = offsetMinutes >= 0 ? '+' : '-';
				const absoluteOffsetMinutes = Math.abs(offsetMinutes);
				const offsetHours = Math.floor(absoluteOffsetMinutes / 60);
				const remainingMinutes = absoluteOffsetMinutes % 60;
				const offset = remainingMinutes
					? `${offsetSign}${offsetHours}:${remainingMinutes.toString().padStart(2, '0')}`
					: `${offsetSign}${offsetHours}`;
				const readableTimezoneName = timezoneName.replace(/_/g, ' ').replace(/\//g, ' ');

				setCurrentTimezone(`GMT${offset} (${readableTimezoneName})`);
			} catch (error) {
				console.error('Error getting timezone:', error);
				setCurrentTimezone('UTC');
			}
		}, 0);

		return () => clearTimeout(timer);
	}, []);

	return { currentTimezone };
}
